import Vue from 'vue';
import VueRouter from 'vue-router';

// dashboard Router
import Dashboard from './dashboard/dashboard';
import DangerCctvPopup from './dashboard/dangerCctvPopup';

// main Router
import Login from './main/login';
import Main from './main/main';
import IronMain from './main/ironMain';
import RecentlyNotice from './main/recentlyNotice';
import DangerReportDetail from './main/dangerReportDetail';

// biz Router
import AccidentPrevent from './biz/accidentPrevent';
import WarnWorkOccur from './biz/warnWorkOccur';
import WarnWorkOccurVideo from './biz/warnWorkOccurVideo';
import DangerOccur from './biz/dangerOccur';
import DangerOccurVideo from './biz/dangerOccurVideo';
import SiteStatistic from './biz/siteStatistic';
import ObjectDangerOccurStatistic from './biz/objectDangerOccurStatistic';
import AccidentStatistic from './biz/accidentStatistic';
import ExemplaryCase from './biz/exemplaryCase';

// mng Router
import Site from './mng/site';
import Company from './mng/company';
import User from './mng/user';
import Menu from './mng/menu';
import RoleGroup from './mng/roleGroup';
import GrpCode from './mng/grpCode';
import CommCode from './mng/commCode';
import Object from './mng/object';
import Target from './mng/target';
import ObjectTarget from './mng/objectTarget';
import WarnWork from './mng/warnWork';
import Cctv from './mng/cctv';
import BasicAiConfig from './mng/basicAiConfig';
import CctvAiConfig from './mng/cctvAiConfig';
import ApiLogCallErr from './mng/apiCallErrLog';
import TreeView from './mng/treeView';
import Notice from './mng/notice';
import CctvDangerAreaConfig from './mng/cctvDangerAreaConfig';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		redirect: '/login',
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		...routes,
		// dashboard Router
		Dashboard,
		DangerCctvPopup,
		// main Router
		Login,
		Main,
		IronMain,
		RecentlyNotice,
		DangerReportDetail,
		// biz Router
		AccidentPrevent,
		WarnWorkOccur,
		WarnWorkOccurVideo,
		DangerOccur,
		DangerOccurVideo,
		SiteStatistic,
		AccidentStatistic,
		ObjectDangerOccurStatistic,
		ExemplaryCase,
		// mng Router
		Site,
		Company,
		User,
		Menu,
		RoleGroup,
		GrpCode,
		CommCode,
		Object,
		ObjectTarget,
		Target,
		WarnWork,
		Cctv,
		BasicAiConfig,
		CctvAiConfig,
		ApiLogCallErr,
		// 추가화면 제작 temp - 추후 자리 맞춰 파일 및 추가내용 이동
		TreeView,
		Notice,
		CctvDangerAreaConfig,
	],
});

export default router;
